<template>
  <div class="detail">
      <div class="info">
          <p>审核记录</p>
          <div class="info_main" style="margin-top:15px">
                  <el-table
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column
                        prop="username"
                        label="审核人员"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="result"
                        label="审核结果"
                        width="180">
                        <template slot-scope="scope">
                            {{scope.row.result == 1?'未审核':scope.row.result == 2?'审核通过':scope.row.result == 3?'审核未通过':''}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="180"
                        prop="auditTime"
                        label="审核时间">
                    </el-table-column>
                    <el-table-column
                        prop="feedback"
                        label="反馈">
                    </el-table-column>
                </el-table>
          </div>
      </div>
      <div class="info">
          <p>基本信息</p>
          <div class="info_main">
              <ul>
                 <li>退货单ID: <span>{{orderDetailsVo.id}}</span></li> 
                 <li>退货理由: <span>{{orderDetailsVo.reason}}</span></li> 
                 <li>提交时间: <span>{{orderDetailsVo.createTime}}</span></li> 
              </ul>
          </div>
      </div>
      <div class="info">
          <p>设备信息</p>
          <div class="info_main">
              <ul>
                 <li style="width:33.3%">设备ID: <span>{{orderDetailsVo.deviceId}}</span></li> 
                 <li style="width:33.3%">设备名称: <span>{{orderDetailsVo.deviceName}}</span></li> 
                 <li style="width:33.3%">退货数量: <span>{{orderDetailsVo.number}}</span></li> 
                 <li style="width:100%" ><span style="float:left;margin-right:10px">设备编码:</span> <span class="devicenum" v-for="item in list" :key="item">{{item}}</span></li> 
              </ul>
          </div>
          <div class="btn">
                    <el-button  v-preventReClick @click="goback()">返回</el-button>
          </div>
      </div>
  </div>
</template>

<script>
import {backOrderDetails,updateOrderState} from '../axios/api'
export default {
    data(){
        return{
            tableData:[],
            flag:false,
            orderDetailsVo:{},
            list:[]
        }
    },
    created(){
        console.log(this.$route.params)
        window.localStorage.setItem('ids',this.$route.params.id)
        this.getdata()
    },
    methods:{
        sureReceipt(){
            this.$confirm('请核对实际收货数量与发货明细中的设备是否一致?', '确认收货', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal:false,
                type: 'warning'
                }).then(async () => {
                    var {data:dt} = await updateOrderState({
                        orderId:window.localStorage.getItem('ids')
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message({
                            type: 'success',
                            message: dt.message
                        });
                        this.getdata()
                    }
                
                this.flag = false
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消收货'
                });          
            });
        },
        async getdata(){
            var {data:dt} = await backOrderDetails({
                id:window.localStorage.getItem('ids')
            })
            console.log(dt)
            if(dt.code == 200){
                this.orderDetailsVo = dt.data.backOrder
                if(dt.data.backOrder.deviceCoding){
                   this.list =  dt.data.backOrder.deviceCoding.split(',')
                }
                let obj = {
                    username:dt.data.backOrder.adminName,
                    result:dt.data.backOrder.status,
                    auditTime:dt.data.backOrder.auditTime,
                    feedback:dt.data.backOrder.rejectReason,
                }
                this.tableData = []
                this.tableData.push(obj)
            }
            
        },
        goback(){
            this.$router.push('/returnorder')
        }
    }
}

</script>
<style lang="less" scoped>
.detail{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .info{
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 15px;
        box-sizing: border-box;
        p{
            font-size: 18px;
            font-weight: 700;
            height: 40px;
            line-height: 40px;
        }
        .info_main{
            ul{
                overflow: hidden;
                width: 100%;
                li{
                    width: 50%;
                    float: left;
                    line-height: 50px;
                    font-size: 14px;
                    .devicenum{
                        padding: 0 10px;
                        background: #f2f2f2;
                        border-radius: 5px;
                        margin-right: 10px;
                        float: left;
                        margin-bottom: 20px;
                    }
                }
            }
        }
        .btn{
            margin-top: 55px;
            button{
                width: 10%;
                margin-right: 2%;
            }
        }
    }
    .info:last-child{
        border-bottom: none;
    }
}
</style>